import { createFileRoute } from "@tanstack/react-router";
import { ssrPage } from "@/ssr/define-page";
import { definePageMeta } from "@/ssr/define-meta";
import { Hero } from "@/components/home/Hero";
import { TopicsSection } from "@/components/home/TopicsSection";
import { TrustedTherapists } from "@/components/home/TrustedTherapists";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Testimonials } from "@/components/home/Testimonials";
import { CompareTherapy } from "@/components/home/CompareTherapy";
import { FaqSection } from "@/components/home/FaqSection";
import { BlogPreview } from "@/components/home/BlogPreview";
import { buildPageStructuredData } from "@/ssr/structured-data";
import { buildFaqPageNode } from "@/ssr/faq-jsonld";
import { filterFaqCategories } from "@/lib/faq-categories";
import type { PublicFaqEnvelope } from "@/api-queries/faq";

const homeMeta = definePageMeta({
  titleKey: "home.meta.title",
  descriptionKey: "home.meta.description",
  ogImage: "/og-home.jpg",
  structuredData: (ctx) => buildPageStructuredData(ctx, {
    titleKey: "home.meta.title",
    descriptionKey: "home.meta.description",
    ogImage: "/og-home.jpg",
    breadcrumbs: [{ name: "Psihotron", path: "/" }],
    mainEntity: ({ url, t }) => ({
      "@type": "Service",
      "@id": `${url.origin}/#online-psychotherapy-service`,
      name: t("home.meta.title"),
      description: t("home.meta.description"),
      serviceType: "Online psychotherapy and counseling platform",
      provider: { "@id": `${url.origin}/#organization` },
      areaServed: {
        "@type": "Country",
        name: "Bosnia and Herzegovina",
      },
      url: url.origin,
    }),
    extraGraph: (ctx, { pageId }) => {
      // Iste kategorije koje FaqSection prikazuje — shema mora odgovarati
      // vidljivom sadržaju, inače Google markup odbija.
      const envelope = ctx.getQueryData?.<PublicFaqEnvelope>(["faq", "public"]);
      if (!envelope?.categories) return [];
      const visible = filterFaqCategories(envelope.categories, "home");
      const node = buildFaqPageNode(visible, ctx.locale, pageId);
      return node ? [node] : [];
    },
  }),
});

function HomePage() {
  return (
    <>
      <Hero.Component />
      <TopicsSection.Component />
      <TrustedTherapists.Component />
      <HowItWorks.Component />
      <Testimonials.Component />
      <CompareTherapy.Component />
      <FaqSection.Component />
      <BlogPreview.Component />
    </>
  );
}

export const Route = createFileRoute("/")(
  ssrPage({
    component: HomePage,
    sections: [Hero, TopicsSection, TrustedTherapists, HowItWorks, Testimonials, CompareTherapy, FaqSection, BlogPreview],
    meta: homeMeta,
  }),
);
